import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'input-password-meter',
  templateUrl: './input-password-meter.component.html',
  styleUrls: ['./input-password-meter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputPasswordMeterComponent implements OnInit {

  @Input() public passControl?: FormControl<any> | AbstractControl;
  @Input() public barLabel: string = 'Passwortstärke';

  public bars: string[] = ['', '', '', '', ''];
  private colors: string[] = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];

  private static measureStrength(pass: string): number {
    let score = 0;
    // award every unique letter until 5 repetitions
    const letters: any = {};
    for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }
    // bonus points for mixing it up
    const variations: any = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass)
    };

    let variationCount = 0;
    // eslint-disable-next-line guard-for-in
    for (const check in variations) {
      variationCount += (variations[check]) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;
    return Math.trunc(score);
  }

  public ngOnInit(): void {
    if (!this.passControl) {
      console.error('passcontrol not set for input-password-meter');
      return;
    }
    this.passControl.valueChanges.pipe(debounceTime(5)).subscribe(
      (val) => {
        this.setBarColors(5, '#DDD');
        if (val) {
          const c = this.getColor(InputPasswordMeterComponent.measureStrength(val));
          this.setBarColors(c.idx, c.col);
        }
      }
    );
  }

  private getColor(score: number): { idx: number, col: string } {
    let idx = 0;
    if (score > 90) {
      idx = 4;
    }
    else if (score > 70) {
      idx = 3;
    }
    else if (score >= 40) {
      idx = 2;
    }
    else if (score >= 20) {
      idx = 1;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  private setBarColors(count: number, col: any): void {
    for (let n = 0; n < count; n++) {
      this.bars[n] = col;
    }
  }

}
